import { Box, TextField } from '@mui/material'
import { useIntl } from 'react-intl'
import RequiredAsterisk from '../../../components/RequiredAsterisk/RequiredAsterisk'
import { SectionLabelTypography, SectionTitleTypography } from '../../../components/Typographies/styles'
import { useRoleFormContext } from './hooks/useRoleFormContext'
import messages from './messages'

type MainInfoProps = {
    isDisabled?: boolean
}

const MainInfo = ({ isDisabled }: MainInfoProps) => {

    const { formatMessage } = useIntl()

    const { values, setFieldValue, errors, touched } = useRoleFormContext()

    const handleTextFieldChange = ({
        target,
    }: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setFieldValue(target.id, target.value)
    }

    const { name, description } = values

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: '16px' }}>
                <SectionTitleTypography>{formatMessage(messages.mainInfoTitle)}</SectionTitleTypography>
            </Box>
            <Box sx={{ mb: '8px' }}>
                <SectionLabelTypography variant='subtitle1' sx={{ mb: '4px' }}>
                    {formatMessage(messages.roleName)}
                    <RequiredAsterisk />
                </SectionLabelTypography>
                <TextField
                    fullWidth
                    id='name'
                    value={name}
                    defaultValue={name}
                    disabled={isDisabled}
                    onChange={handleTextFieldChange}
                    error={touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                />
            </Box>
            <Box sx={{ mb: '8px' }}>
                <SectionLabelTypography variant='subtitle1' sx={{ mb: '4px' }}>
                    {formatMessage(messages.description)}
                    <RequiredAsterisk />
                </SectionLabelTypography>
                <TextField
                    fullWidth
                    id='description'
                    value={description}
                    defaultValue={description}
                    disabled={isDisabled}
                    onChange={handleTextFieldChange}
                    error={touched.description && !!errors.description}
                    helperText={touched.description && errors.description}
                />
            </Box>
        </Box>
    )
}

export default MainInfo